import { getHeaders, CheckAuth } from 'auth/auth';
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../baseQuery';

const isUuidLike = (value) => {
  if (!value) return false;
  return /^[0-9a-fA-F-]{36}$/.test(String(value));
};

const resolvePortalPrefix = () => {
  const cachedUser = CheckAuth() || {};
  const role = String(cachedUser.role || cachedUser.originalRole || '').toLowerCase();
  const userId = cachedUser.user_id;

  if (role === 'consumer' || isUuidLike(userId)) {
    return '/b2c';
  }

  return '/b2b';
};

const withPortalPrefix = (path = '') => {
  const prefix = resolvePortalPrefix();
  if (!path) return prefix;
  if (path.startsWith('/b2b') || path.startsWith('/b2c')) return path;
  if (path.startsWith('/')) return `${prefix}${path}`;
  return `${prefix}/${path}`;
};

export const pipelineAPI = createApi({
  reducerPath: 'pipeline',
  tagTypes: ['updatePipeline'],
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    // B2C consumer pipeline (My Loans)
    getPipeline: builder.query({
      query: () => {
        return {
          url: `b2c/loan/pipeline/applications`,
          method: 'GET',
          headers: getHeaders(),
        };
      },
      providesTags: ['updatePipeline'],
    }),
    // Application status dropdown - uses role-aware routing
    getPipelineStatus: builder.query({
      query: () => {
        return {
          url: withPortalPrefix('/loan/application_dropdowns/application_status'),
          method: 'GET',
          headers: getHeaders(),
        };
      },
    }),
    // B2B application status dropdown for B2C pipeline UI parity
    getB2bPipelineStatus: builder.query({
      query: () => {
        return {
          url: '/b2b/loan/application_dropdowns/application_status',
          method: 'GET',
          headers: getHeaders(),
        };
      },
    }),
    // Update consumer application status
    updatePipelineStatus: builder.mutation({
      query: ({ applicationId, data }) => {
        return {
          url: `b2c/loan/application/status/${applicationId}`,
          method: 'PUT',
          body: data,
          headers: getHeaders(),
        };
      },
      invalidatesTags: ['updatePipeline'],
    }),
  }),
});

export const {
  useGetPipelineQuery,
  useGetPipelineStatusQuery,
  useGetB2bPipelineStatusQuery,
  useUpdatePipelineStatusMutation,
} = pipelineAPI;
